export default "__VITE_ASSET__CAIwD43K__"